import React, { useMemo, useState } from "react";
import { Tooltip, Modal } from "antd";
import { IconEmailAlert } from "../../../../../Layout/Icons";
import { prettyDateFormat } from "../../../../../../helpers/Utils";

const ShipmentEmailPreview = ({ tracking_number, shipment_emails }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const emails = useMemo(() => {
    return shipment_emails.filter((d) => d.tracking_number === tracking_number);
  }, [shipment_emails]);


  if (!!emails.length) {
    return (
      <>
        <Tooltip placement="left" title="Open more info in mail">
          <div
            className="d-flex align-items-center justify-content-center p-1 mr-2"
            style={{
              background: "#FDEACF",
              border: "0.809524px solid #F29302",
              borderRadius: 33,
            }}
            onClick={() => setIsModalOpen(true)}
          >
            <IconEmailAlert />
          </div>
        </Tooltip>
        {isModalOpen && (
          <Modal
            title={tracking_number}
            visible={true}
            onCancel={() => setIsModalOpen(false)}
            cancelText="Close"
            okButtonProps={{ style: { display: "none" } }}
          >
            {emails.map(
              ({ id, shipment_id, sender_email, body, subject, created_at }) => (
                <div
                  key={`shipment_email_${id}_${shipment_id}_${tracking_number}`}
                  className="mt-1 bg-light-primary"
                  style={{
                    padding: "8px 8px 5px",
                    borderRadius: 2,
                  }}
                >
                  <div className="d-flex align-items-center justify-content-between">
                    <p
                      className="mb-0"
                      style={{
                        color: "#014894",
                        fontWeight: 400,
                        fontSize: 10,
                        lineHeight: 1,
                      }}
                    >
                      {subject} - {sender_email}
                    </p>
                    <p className="text-black mb-0 text-xs font-normal">
                      {prettyDateFormat(created_at)}
                    </p>
                  </div>
                  <p className="text-black mb-0 text-xs font-normal overflow-x-auto" dangerouslySetInnerHTML={{__html: body}}></p>
                </div>
              )
            )}
          </Modal>
        )}
      </>
    );
  }

  return null;
};

export default ShipmentEmailPreview;
